@if (piData) {
<div id="main-content" class="wrapper has-padding margin-height zoom-margin margin-bottom-overflow"
  (focusout)="onFocusOutMainContent($event)">
  <h1 class="bofa--heading is-4">Personal information</h1>
  <form [formGroup]="piGroup" (ngSubmit)="onSubmit()">
    <p class="global-red min-font">
      Fields below are required unless otherwise stated
      <abbr title="required">*</abbr>.
    </p>
    <h2 class="bofa--heading is-7" id="genaral-info-label">
      General information
    </h2>
    <mat-form-field class="max-width max-zoom radio-padding minor-list-space width-350" hideRequiredMarker>
      <mat-label id="first-name-label"><abbr title="required">* </abbr>First name</mat-label>
      <input matInput formControlName="firstName" required maxlength="100"
        aria-labelledby="genaral-info-label first-name-label" />
      <mat-error>Please enter First name</mat-error>
    </mat-form-field>
    @if (!requireMiddleNameLockbox) {
    <div>
      <div class="bottom-space">
        <mat-form-field class="radio-padding width-350">
          <mat-label>Middle name (optional)</mat-label>
          <input matInput formControlName="middleName" maxlength="100" />
        </mat-form-field>
      </div>
    </div>
    }
    @if (requireMiddleNameLockbox) {
    <div>
      <mat-form-field class="bottom-space max-width max-zoom width-350" hideRequiredMarker>
        <mat-label><abbr title="required">* </abbr>Middle name</mat-label>
        <input matInput formControlName="middleName" required maxlength="100" />
        <mat-error>Please enter Middle name</mat-error>
      </mat-form-field>
    </div>
    }
    <mat-form-field class="max-width max-zoom radio-padding minor-list-space width-350" hideRequiredMarker>
      <mat-label><abbr title="required">* </abbr>Last name</mat-label>
      <input matInput formControlName="lastName" required maxlength="100" />
      <mat-error>Please enter Last name</mat-error>
    </mat-form-field>
    <div class="bottom-space radio-padding">
      <mat-form-field class="radio-padding width-350">
        <mat-label>Suffix (e.g. Jr., III) (optional)</mat-label>
        <input matInput formControlName="suffix" maxlength="50" />
      </mat-form-field>
    </div>
    @if (jobCountryCode === 'IND' && !ousFlag) {
    <div class="margin-bottom-overflow">
      <div class="bottom-space width-350">
        <mat-hint><strong>
            <p>Either Father's Full Name or Mother's Full Name is mandatory.</p>
            <p>
              To avoid delays in the background check process please ensure your
              Father’s/Mother’s name is as per your PAN card.
            </p>
          </strong></mat-hint>
      </div>
      <div class="bottom-space max-width">
        <mat-form-field class="max-width max-zoom minor-list-space width-350" hideRequiredMarker>
          <mat-label><abbr title="required">* </abbr>Mother's/Father's Name</mat-label>
          <mat-select formControlName="motherOrFather" required (selectionChange)="fatherOrMother($event)">
            <mat-option>Select</mat-option>
            @for (parent of fatherOrMotherSelection; track parent) {
            <mat-option [value]="parent.id">
              {{ parent.value }}
            </mat-option>
            }
          </mat-select>
          <mat-error>Please select Mother or Father Name</mat-error>
        </mat-form-field>
      </div>
      @if (motherOrFather.value === 2) {
      <div>
        <div class="bottom-space max-width">
          <mat-form-field class="max-width max-zoom radio-padding minor-list-space width-350" hideRequiredMarker>
            <mat-label><abbr title="required">* </abbr>Father's First Name</mat-label>
            <input matInput formControlName="fatherFirstName" required maxlength="100" />
            <mat-hint><strong>Do not use initials</strong></mat-hint>
            <mat-error>Please enter Father's First Name</mat-error>
          </mat-form-field>
        </div>
        <div class="bottom-space max-width">
          <mat-form-field class="max-width max-zoom radio-padding minor-list-space width-350" hideRequiredMarker>
            <mat-label>Father's Middle Name</mat-label>
            <input matInput formControlName="fatherMiddleName" maxlength="100" />
            <mat-error>Please enter valid Father's Middle Name</mat-error>
          </mat-form-field>
        </div>
        <div class="bottom-space max-width">
          <mat-form-field class="max-width max-zoom radio-padding minor-list-space width-350" hideRequiredMarker>
            <mat-label><abbr title="required">* </abbr>Father's Last Name</mat-label>
            <input matInput formControlName="fatherLastName" required maxlength="100" />
            <mat-hint><strong>Do not use initials</strong></mat-hint>
            <mat-error>Please enter Father's Last Name</mat-error>
          </mat-form-field>
        </div>
      </div>
      }
      @if (motherOrFather.value === 1) {
      <div>
        <div class="bottom-space max-width">
          <mat-form-field class="max-width max-zoom radio-padding minor-list-space width-350" hideRequiredMarker>
            <mat-label><abbr title="required">* </abbr>Mother's First Name</mat-label>
            <input matInput formControlName="motherFirstName" required maxlength="100" />
            <mat-hint><strong>Do not use initials</strong></mat-hint>
            <mat-error>Please enter Mother's First Name</mat-error>
          </mat-form-field>
        </div>
        <div class="bottom-space max-width">
          <mat-form-field class="max-width max-zoom radio-padding minor-list-space width-350" hideRequiredMarker>
            <mat-label>Mother's Middle Name</mat-label>
            <input matInput formControlName="motherMiddleName" maxlength="100" />
            <mat-error>Please enter valid Mother's Middle Name</mat-error>
          </mat-form-field>
        </div>
        <div class="bottom-space max-width">
          <mat-form-field class="max-width max-zoom radio-padding minor-list-space width-350" hideRequiredMarker>
            <mat-label><abbr title="required">* </abbr>Mother's Last Name</mat-label>
            <input matInput formControlName="motherLastName" required maxlength="100" />
            <mat-hint><strong>Do not use initials</strong></mat-hint>
            <mat-error>Please enter Mother's Last Name</mat-error>
          </mat-form-field>
        </div>
      </div>
      }
    </div>
    }
    @if (jobCountry === jobCountryUSA || jobCountryCode === 'IND') {
    <div>
      <div class="bottom-space max-width">
        <div id="gender-radio-group-label" class="minor-list-space">
          <abbr title="required">* </abbr>Gender
        </div>
        <mat-radio-group name="radioGender" class="minor-radio-padding" aria-describedby="gender-radio-group-label"
          formControlName="gender" (change)="radioOnChange($event)" (focusin)="radioOnFocus($event)"
          (focusout)="radioOnFocusOut($event)">
          <mat-radio-button class="minor-list-space radio-padding" matInput value="1" name="gender">Male
          </mat-radio-button>
          <mat-radio-button class="minor-radio-padding" matInput value="2" name="gender">Female</mat-radio-button>
          @if (submit && gender.hasError('required')) {
          <mat-error>Please select Gender</mat-error>
          }
        </mat-radio-group>
      </div>
      <!-- Hidden divs are for screen readers -->
      <div class="bofa--skiplink">
        @if (submit && showRadioGender) {
        <mat-error>
          Please select Gender
        </mat-error>
        }
      </div>
    </div>
    }
    <!--Start as part of story BSITECHNO-46717 including these field's to OUS country -->
    @if (
    jobCountry !== jobCountryUSA && jobCountryCode !== 'IND' && !skinnyForm
    ) {
    <div class="max-width">
      <mat-form-field class="max-width max-zoom minor-list-space width-350" hideRequiredMarker>
        <mat-label><abbr title="required">* </abbr>Birth Place</mat-label>
        <input matInput formControlName="cityBorn" required maxlength="100" />
        <mat-error>Please enter your Birth Place</mat-error>
      </mat-form-field>
    </div>
    }
    @if (showCountryOfBirth && !skinnyForm) {
    <div>
      <mat-form-field class="max-width max-zoom minor-list-space width-350" hideRequiredMarker>
        <mat-label><abbr title="required">* </abbr>Birth Country</mat-label>
        <mat-select formControlName="countryOfBirth" required>
          <mat-option>Select</mat-option>
          @for (
          country of piData.countryLookup | keyvalue : valueAscOrder
          ; track
          country) {
          <mat-option [value]="country.key">
            {{ country.value }}
          </mat-option>
          }
        </mat-select>
        @if (countryOfBirth.hasError('required')) {
        <mat-error>Please select Country of Birth
        </mat-error>
        }
      </mat-form-field>
    </div>
    }
    @if (
    jobCountry !== jobCountryUSA && jobCountryCode !== 'IND' && !skinnyForm
    ) {
    <div class="max-width">
      <mat-form-field class="max-width max-zoom minor-list-space width-350" hideRequiredMarker>
        <mat-label><abbr title="required">* </abbr>Mother's Maiden Name</mat-label>
        <input matInput formControlName="motherMaidenName" required maxlength="100" />
        <mat-error>Please enter your Mother's Maiden Name</mat-error>
      </mat-form-field>
    </div>
    }
    <!-- End -->
    @if (jobCountry === jobCountryUSA) {
    <div>
      <div id="date-group-label" class="margin-bottom-5">
        <abbr title="required">* </abbr>Date of Birth
      </div>
      <mat-form-field aria-describedby="date-group-label" class="max-width width-160" hideRequiredMarker>
        <mat-label><abbr title="required">* </abbr>Month</mat-label>
        <mat-select formControlName="dateOfBirthMonth" required>
          <mat-option>Select</mat-option>
          @for (month of piData.monthLookup | keyvalue : descOrder; track month) {
          <mat-option [value]="month.key">
            {{ month.value }}
          </mat-option>
          }
        </mat-select>
        <mat-hint class="bofa--skiplink">{{
          dropDownScreenReaderMonth()
          }}</mat-hint>
        @if (dateOfBirthMonth.hasError('required')) {
        <mat-error>Please select Month</mat-error>
        }
      </mat-form-field>
      <mat-form-field aria-describedby="date-group-label" class="max-width width-150" hideRequiredMarker>
        <mat-label><abbr title="required">* </abbr>Day</mat-label>
        <mat-select formControlName="dateOfBirthDay" [compareWith]="compareSelectValueFn" required>
          <mat-option>Select</mat-option>
          @for (day of days; track day; let i = $index) {
          <mat-option [value]="day">
            {{ day }}
          </mat-option>
          }
        </mat-select>
        <mat-hint class="bofa--skiplink">{{
          dropDownScreenReaderDay()
          }}</mat-hint>
        @if (dateOfBirthDay.hasError('required')) {
        <mat-error>Please select Day
        </mat-error>
        }
      </mat-form-field>
      <mat-form-field aria-describedby="date-group-label" class="max-width width-150" hideRequiredMarker>
        <mat-label><abbr title="required">* </abbr>Year</mat-label>
        <mat-select formControlName="dateOfBirthYear" [compareWith]="compareSelectValueFn" required>
          <mat-option>Select</mat-option>
          @for (year of years; track year; let i = $index) {
          <mat-option [value]="year">
            {{ year }}
          </mat-option>
          }
        </mat-select>
        <mat-hint class="bofa--skiplink">{{
          dropDownScreenReaderYear()
          }}</mat-hint>
        @if (dateOfBirthYear.hasError('required')) {
        <mat-error>Please select Year</mat-error>
        }
      </mat-form-field>
      @if (dateOfBirthYear.hasError('futureDate')) {
      <mat-error>Please enter a Date of Birth that is not in the future</mat-error>
      }
    </div>
    }
    @if (jobCountry !== jobCountryUSA) {
    <div>
      <div id="date-group-label" class="margin-bottom-5">Date of Birth</div>
      <mat-form-field aria-describedby="date-group-label" class="max-width width-160">
        <mat-label>Month</mat-label>
        <mat-select formControlName="inputOusMonth" (selectionChange)="handleSelection($event, 'month')">
          <mat-option value="0">**</mat-option>
          @for (month of piData.monthLookup | keyvalue : descOrder; track month) {
          <mat-option [value]="month.key">
            {{ month.value }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field aria-describedby="date-group-label" class="max-width width-150">
        <mat-label>Day</mat-label>
        <mat-select formControlName="inputOusDay" [compareWith]="compareSelectValueFn"
          (selectionChange)="handleSelection($event, 'day')">
          <mat-option value="0">**</mat-option>
          @for (day of days; track day; let i = $index) {
          <mat-option [value]="day">
            {{ day }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field aria-describedby="date-group-label" class="max-width width-150">
        <mat-label>Year</mat-label>
        <mat-select formControlName="inputOUsYear" [compareWith]="compareSelectValueFn"
          (selectionChange)="handleSelection($event, 'year')">
          <mat-option value="0">****</mat-option>
          @for (year of years; track year; let i = $index) {
          <mat-option [value]="year">
            {{ year }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (inputOUsYear.hasError('futureDate')) {
      <mat-error>Please enter a Date of Birth that is not in the future</mat-error>
      }
      <div id="date-group-label" class="margin-bottom-5">
        <abbr title="required">* </abbr>Verify Date of Birth
      </div>
      <mat-form-field aria-describedby="date-group-label" class="max-width width-160" hideRequiredMarker>
        <mat-label><abbr title="required">* </abbr>Month</mat-label>
        <mat-select formControlName="dateOfBirthMonth" required>
          <mat-option>Select</mat-option>
          @for (month of piData.monthLookup | keyvalue : descOrder; track month) {
          <mat-option [value]="month.key">
            {{ month.value }}
          </mat-option>
          }
        </mat-select>
        <mat-hint class="bofa--skiplink">{{
          dropDownScreenReaderMonth()
          }}</mat-hint>
        @if (dateOfBirthMonth.hasError('required')) {
        <mat-error>Please select Month</mat-error>
        }
      </mat-form-field>
      <mat-form-field aria-describedby="date-group-label" class="max-width width-150" hideRequiredMarker>
        <mat-label><abbr title="required">* </abbr>Day</mat-label>
        <mat-select formControlName="dateOfBirthDay" [compareWith]="compareSelectValueFn" required>
          <mat-option>Select</mat-option>
          @for (day of days; track day; let i = $index) {
          <mat-option [value]="day">
            {{ day }}
          </mat-option>
          }
        </mat-select>
        <mat-hint class="bofa--skiplink">{{
          dropDownScreenReaderDay()
          }}</mat-hint>
        @if (dateOfBirthDay.hasError('required')) {
        <mat-error>Please select Day
        </mat-error>
        }
      </mat-form-field>
      <mat-form-field aria-describedby="date-group-label" class="max-width width-150" hideRequiredMarker>
        <mat-label><abbr title="required">* </abbr>Year</mat-label>
        <mat-select formControlName="dateOfBirthYear" [compareWith]="compareSelectValueFn" required>
          <mat-option>Select</mat-option>
          @for (year of years; track year; let i = $index) {
          <mat-option [value]="year">
            {{ year }}
          </mat-option>
          }
        </mat-select>
        <mat-hint class="bofa--skiplink">{{
          dropDownScreenReaderYear()
          }}</mat-hint>
        @if (dateOfBirthYear.hasError('required')) {
        <mat-error>Please select Year</mat-error>
        }
      </mat-form-field>
      @if (dateOfBirthYear.hasError('futureDate')) {
      <mat-error>Please enter a Date of Birth that is not in the future</mat-error>
      }
    </div>
    }
    <h2 class="bofa--heading is-4">Identification information</h2>
    <mat-form-field class="max-width max-zoom minor-list-space width-350" hideRequiredMarker>
      <mat-label><abbr title="required">* </abbr>Email Address</mat-label>
      <input matInput formControlName="email" required maxlength="200" />
      @if (email.hasError('required')) {
      <mat-error>Please enter Email Address</mat-error>
      }
      @if (email.hasError('email')) {
      <mat-error>Please enter valid Email Address</mat-error>
      }
    </mat-form-field>
    <div>
      <mat-form-field class="bottom-space max-width max-zoom width-350" hideRequiredMarker>
        <mat-label><abbr title="required">* </abbr>Phone Number@if (jobCountryCode !== jobCountryUSA) {
          <span>
            (including country code)</span>
          }
        </mat-label>
        <input matInput formControlName="primaryPhone" required maxlength="25" />
        <mat-error>Please enter a valid Phone number (minimum of 5 and maximum of 25, only '+()-'
          special characters allowed)</mat-error>
      </mat-form-field>
    </div>
    <div class="margin-bottom-2">
      <mat-form-field class="radio-padding width-350">
        <mat-label>Secondary phone number (optional)</mat-label>
        <input matInput formControlName="secondPhone" maxlength="25" />
        <mat-error>Please enter a valid Phone number (minimum of 5 and maximum of 25, only '+()-'
          special characters allowed)</mat-error>
      </mat-form-field>
    </div>
    @if (jobCountry === jobCountryUSA && !ousFlag) {
    <div>
      <div class="in-line">
        <mat-form-field class="max-width max-zoom minor-list-space width-350" hideRequiredMarker>
          <mat-label><abbr title="required">* </abbr>SSN/National ID</mat-label>
          <input matInput formControlName="ssn" [type]="'password'" maxlength="25" required autocomplete="off" />
          <mat-error>Please enter SSN/National ID</mat-error>
        </mat-form-field>
        <img matTooltip="National ID Summary Document" matTooltipPosition="below" (keydown.enter)="getIDDocument()"
          (click)="getIDDocument()" tabindex="0" alt="National ID Summary Document" src="assets/ID_icon.png"
          class="img-action" />
      </div>
      <div>
        <mat-form-field class="bottom-space max-width max-zoom width-350" hideRequiredMarker>
          <mat-label>
            <abbr title="required">* </abbr>Verify SSN/National ID</mat-label>
          <input matInput formControlName="confirmSsn" [type]="'password'" maxlength="25" required autocomplete="off" />
          <mat-error>Please enter SSN/National ID</mat-error>
        </mat-form-field>
      </div>
    </div>
    }
    @if (ousFlag && !skinnyForm) {
    <div class="margin-bottom-2">
      <div class="in-line">
        <mat-form-field class="max-width max-zoom minor-list-space width-350" hideRequiredMarker>
          <mat-label><abbr title="required">* </abbr>Country of National ID</mat-label>
          <mat-select formControlName="nationalIdCountry" required>
            <mat-option>Select</mat-option>
            @for (
            country of piData.countryLookup | keyvalue : valueAscOrder
            ; track
            country) {
            <mat-option [value]="country.key">
              {{ country.value }}
            </mat-option>
            }
          </mat-select>
          @if (nationalIdCountry.hasError('required')) {
          <mat-error>Please select Country of National ID
          </mat-error>
          }
        </mat-form-field>
        <mat-form-field class="max-width max-zoom minor-list-space width-350" hideRequiredMarker>
          <mat-label><abbr title="required">* </abbr>National ID</mat-label>
          <input matInput formControlName="nationalId" maxlength="100" required />
          <mat-error>Please enter National ID</mat-error>
        </mat-form-field>
        <img matTooltip="National ID Summary Document" matTooltipPosition="below" (keydown.enter)="getIDDocument()"
          (click)="getIDDocument()" tabindex="0" alt="National ID Summary Document" src="assets/ID_icon.png"
          class="img-action" />
      </div>
    </div>
    }
    @if (afCountryQuestionsList && afCountryQuestionsList.length > 0) {
    <div>
      <div formArrayName="afCountryQuestionsList">
        @for (
        question of afCountryQuestionsList.controls; track
        question; let i = $index) {
        <div [formGroupName]="i">
          <label [attr.for]="'answerField-' + i" [id]="'answerField-label-' + i" class="dynamic-question-label">
            @if (isRequiredQuestion(question.get('questionId').value)) {
            <span>
              <abbr title="required">* </abbr>
            </span>
            }
            {{ question.get("questions").value }}
            @if (!isRequiredQuestion(question.get('questionId').value)) {
            <span>
              (optional)
            </span>
            }
          </label>
          <mat-form-field class="max-zoom field-space width-350" [ngClass]="{
              'non-required': !isRequiredQuestion(
                question.get('questionId').value
              )
            }">
            <input matInput formControlName="answerField" maxlength="400" [id]="'answerField-' + i"
              [required]="isRequiredQuestion(question.get('questionId').value)"
              [attr.aria-labelledby]="'answerField-label-' + i" />
            @if (
            isRequiredQuestion(question.get('questionId').value) &&
            question.get('answerField').hasError('required')
            ) {
            <mat-error>
              Please enter a valid response
            </mat-error>
            }
          </mat-form-field>
        </div>
        }
      </div>
    </div>
    }
    @if (!ousFlag) {
    <div>
      <h2 class="bofa--heading is-4">Additional information</h2>
      @if (jobCountry !== jobCountryUSA) {
      <div>
        <div class="double-bottom-space max-width">
          <div id="usCitizen-radio-group-label" class="minor-list-space">
            <abbr title="required">* </abbr>Are you a US Citizen?
          </div>
          <mat-radio-group name="radioUSCitizen" class="minor-radio-padding"
            aria-describedby="usCitizen-radio-group-label" formControlName="usCitizen"
            (change)="hasUSCitizenChange($event)" (focusin)="radioOnFocus($event)" (focusout)="radioOnFocusOut($event)">
            <mat-radio-button class="minor-list-space radio-padding" matInput value="1"
              name="usCitizen">Yes</mat-radio-button>
            <mat-radio-button class="minor-radio-padding" matInput value="2" name="usCitizen">No</mat-radio-button>
            @if (submit && usCitizen.hasError('required')) {
            <mat-error>Please select Yes or No</mat-error>
            }
          </mat-radio-group>
        </div>
        @if (isUSCitizen) {
        <div class="double-bottom-space">
          <p>
            <strong><u>Supporting Documents to be Submitted: </u></strong>
          </p>
          <ul class="ul-no-style">
            <li>Copy of Social Security Card</li>
            <li>Copy of Passport</li>
          </ul>
        </div>
        }
        <div class="double-bottom-space max-width">
          <div id="usGreenCard-radio-group-label" class="minor-list-space">
            <abbr title="required">* </abbr>Are you a US Greencard Holder?
          </div>
          <mat-radio-group name="radioUSGreenCard" class="minor-radio-padding"
            aria-describedby="usGreenCard-radio-group-label" formControlName="usGreenCard"
            (change)="hasUSGreenCardChange($event)" (focusin)="radioOnFocus($event)"
            (focusout)="radioOnFocusOut($event)">
            <mat-radio-button class="minor-list-space radio-padding" matInput value="1"
              name="usGreenCard">Yes</mat-radio-button>
            <mat-radio-button class="minor-radio-padding" matInput value="2" name="usGreenCard">No</mat-radio-button>
            @if (submit && usGreenCard.hasError('required')) {
            <mat-error>Please select Yes or No</mat-error>
            }
          </mat-radio-group>
        </div>
        @if (hasUSGreenCard) {
        <div class="double-bottom-space max-width">
          <div class="bottom-space">
            <mat-form-field class="max-width max-zoom minor-list-space width-350" hideRequiredMarker>
              <mat-label><abbr title="required">* </abbr>US Greencard Document
                Number</mat-label>
              <input matInput formControlName="usGreenCardDocumentNumber" maxlength="25" required />
              <mat-error>Please enter US Greencard Document Number</mat-error>
            </mat-form-field>
          </div>
          <div id="usgc-group-label" class="margin-bottom-5">
            <abbr title="required">* </abbr>US Greencard Issue Date
          </div>
          <div class="bottom-space">
            <mat-form-field aria-describedby="usgc-group-label" class="max-width width-160" hideRequiredMarker>
              <mat-label><abbr title="required">* </abbr>Month</mat-label>
              <mat-select formControlName="usGreenCardIssueMonth" required>
                <mat-option>Select</mat-option>
                @for (
                month of piData.monthLookup | keyvalue : descOrder
                ; track
                month) {
                <mat-option [value]="month.key">
                  {{ month.value }}
                </mat-option>
                }
              </mat-select>
              <mat-hint class="bofa--skiplink">{{
                dropDownScreenReaderMonth()
                }}</mat-hint>
              @if (usGreenCardIssueMonth.hasError('required')) {
              <mat-error>Please select Month</mat-error>
              }
            </mat-form-field>
            <mat-form-field aria-describedby="usgc-group-label" class="max-width width-150" hideRequiredMarker>
              <mat-label><abbr title="required">* </abbr>Day</mat-label>
              <mat-select formControlName="usGreenCardIssueDay" [compareWith]="compareSelectValueFn" required>
                <mat-option>Select</mat-option>
                @for (day of days; track day; let i = $index) {
                <mat-option [value]="day">
                  {{ day }}
                </mat-option>
                }
              </mat-select>
              <mat-hint class="bofa--skiplink">{{
                dropDownScreenReaderDay()
                }}</mat-hint>
              @if (usGreenCardIssueDay.hasError('required')) {
              <mat-error>Please select Day
              </mat-error>
              }
            </mat-form-field>
            <mat-form-field aria-describedby="usgc-group-label" class="max-width width-150" hideRequiredMarker>
              <mat-label><abbr title="required">* </abbr>Year</mat-label>
              <mat-select formControlName="usGreenCardIssueYear" [compareWith]="compareSelectValueFn" required>
                <mat-option>Select</mat-option>
                @for (year of years; track year; let i = $index) {
                <mat-option [value]="year">
                  {{ year }}
                </mat-option>
                }
              </mat-select>
              <mat-hint class="bofa--skiplink">{{
                dropDownScreenReaderYear()
                }}</mat-hint>
              @if (usGreenCardIssueYear.hasError('required')) {
              <mat-error>Please select Year</mat-error>
              }
            </mat-form-field>
            @if (usGreenCardIssueYear.hasError('futureDate')) {
            <mat-error>Please enter a Date that is not in the future</mat-error>
            }
          </div>
          <div id="usgc-group-label" class="margin-bottom-5">
            <abbr title="required">* </abbr>US Greencard Expiry Date
          </div>
          <div class="bottom-space">
            <mat-form-field aria-describedby="usgc-group-label" class="max-width width-160" hideRequiredMarker>
              <mat-label><abbr title="required">* </abbr>Month</mat-label>
              <mat-select formControlName="usGreenCardExpiryMonth" required>
                <mat-option>Select</mat-option>
                @for (
                month of piData.monthLookup | keyvalue : descOrder
                ; track
                month) {
                <mat-option [value]="month.key">
                  {{ month.value }}
                </mat-option>
                }
              </mat-select>
              <mat-hint class="bofa--skiplink">{{
                dropDownScreenReaderMonth()
                }}</mat-hint>
              @if (usGreenCardExpiryMonth.hasError('required')) {
              <mat-error>Please select Month</mat-error>
              }
            </mat-form-field>
            <mat-form-field aria-describedby="usgc-group-label" class="max-width width-150" hideRequiredMarker>
              <mat-label><abbr title="required">* </abbr>Day</mat-label>
              <mat-select formControlName="usGreenCardExpiryDay" [compareWith]="compareSelectValueFn" required>
                <mat-option>Select</mat-option>
                @for (day of days; track day; let i = $index) {
                <mat-option [value]="day">
                  {{ day }}
                </mat-option>
                }
              </mat-select>
              <mat-hint class="bofa--skiplink">{{
                dropDownScreenReaderDay()
                }}</mat-hint>
              @if (usGreenCardExpiryDay.hasError('required')) {
              <mat-error>Please select Day
              </mat-error>
              }
            </mat-form-field>
            <mat-form-field aria-describedby="usgc-group-label" class="max-width width-150" hideRequiredMarker>
              <mat-label><abbr title="required">* </abbr>Year</mat-label>
              <mat-select formControlName="usGreenCardExpiryYear" [compareWith]="compareSelectValueFn" required>
                <mat-option>Select</mat-option>
                @for (year of years; track year; let i = $index) {
                <mat-option [value]="year">
                  {{ year }}
                </mat-option>
                }
              </mat-select>
              <mat-hint class="bofa--skiplink">{{
                dropDownScreenReaderYear()
                }}</mat-hint>
              @if (usGreenCardExpiryYear.hasError('required')) {
              <mat-error>Please select Year</mat-error>
              }
            </mat-form-field>
            @if (usGreenCardExpiryYear.hasError('futureDate')) {
            <mat-error>Please enter a Date that is not in the future</mat-error>
            }
          </div>
          <mat-form-field class="max-width max-zoom minor-list-space width-350" hideRequiredMarker>
            <mat-label><abbr title="required">* </abbr>Social Security Number</mat-label>
            <input matInput formControlName="usGreenCardSSN" maxlength="25" required type="password" />
            <mat-error>Please enter Social Security Number</mat-error>
          </mat-form-field>
          <p>
            <strong><u>Supporting Documents to be Submitted: </u></strong>
          </p>
          <ul class="ul-no-style">
            <li>Copy of US Greencard (Front & Back)</li>
            <li>Copy of Social Security Card</li>
          </ul>
        </div>
        }
      </div>
      }
      @if (piData.applicantType != 'Internal') {
      <p id="prev-radio-group">
        <abbr title="required">*</abbr> Have you ever worked for Bank of America
        Corporation* or any of its related companies, affiliates or
        subsidiaries, including any predecessor organizations, such as Merrill
        Lynch or Countrywide?
      </p>
      }
      @if (piData.applicantType != 'Internal') {
      <div class="sub-label max-width max-zoom minor-list-space">
        *BA - Bank of America, Barnett Bank, Boatman's Bank, C&S Sovran,
        Continental Bank, Continental Illinois Corporation, Countrywide
        Financial, First Republic Bank, Fleet, Florida South Carolina, LaSalle
        Bank, Maryland National Corporation, Merrill Lynch, Nations Bank, North
        Carolina National Bank - Texas, Seafirst, Security Pacific National
        Bank, US Trust
      </div>
      }
      @if (piData.applicantType != 'Internal') {
      <mat-radio-group name="radioPrevBank" aria-describedby="prev-radio-group" class="bottom-space minor-radio-padding"
        formControlName="prevBank" required (change)="onWasWorkedInBoaFlagChange($event)"
        (focusin)="radioOnFocus($event)" (focusout)="radioOnFocusOut($event)">
        <mat-radio-button class="minor-list-space radio-padding" value="1">Yes</mat-radio-button>
        <mat-radio-button class="minor-radio-padding" value="0">No</mat-radio-button>
        @if (submit && prevBank.hasError('required')) {
        <mat-error>Please select Have you ever worked for Bank of America Corporation*
          or any of its related companies, affiliates or subsidiaries, including
          any predecessor organizations, such as Merrill Lynch or
          Countrywide?</mat-error>
        }
      </mat-radio-group>
      }
      @if (piData.applicantType != 'Internal') {
      <div class="bofa--skiplink">
        @if (submit && showRadioPrevBank) {
        <mat-error>
          Please select Have you ever worked for Bank of America Corporation* or
          any of its related companies, affiliates or subsidiaries, including
          any predecessor organizations, such as Merrill Lynch or Countrywide
        </mat-error>
        }
      </div>
      }
      @if (showWasWorkedInBoa && piData.applicantType != 'Internal') {
      <div class="container max-width padding-top text-align">
        <div class="has-background cool-gray-5 optional-box">
          <mat-form-field class="width-260-top-padding-right">
            <input matInput [matDatepicker]="prevBankFromDatePicker" [min]="minDate" [max]="maxDate"
              formControlName="prevBankFromDate" placeholder="From Date (if known)" maxLength="100" />
            <mat-datepicker-toggle matSuffix [for]="prevBankFromDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #prevBankFromDatePicker></mat-datepicker>
            <mat-hint>Format mm/dd/yyyy</mat-hint>
            @if (prevBankFromDate.errors) {
            <mat-error>Please enter valid From date</mat-error>
            }
          </mat-form-field>
          <mat-form-field class="max-width width-260-padding-right">
            <input matInput [matDatepicker]="prevBankEndDatePicker" [min]="minDate" [max]="maxDate"
              formControlName="prevBankEndDate" placeholder="To Date (if known)" maxLength="100" />
            <mat-datepicker-toggle matSuffix [for]="prevBankEndDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #prevBankEndDatePicker></mat-datepicker>
            <mat-hint>Format mm/dd/yyyy</mat-hint>
            @if (prevBankEndDate.errors) {
            <mat-error>Please enter valid To date</mat-error>
            }
          </mat-form-field>
          <mat-form-field class="max-width width-260-padding-right">
            <mat-label>Person Number (if known)</mat-label>
            <input matInput formControlName="personNumber" maxLength="60" />
            <mat-error>Please enter a valid Person Number</mat-error>
          </mat-form-field>
          <mat-form-field class="max-width width-260-padding-right">
            <mat-label>Subsidiary/Bank affiliates</mat-label>
            <mat-select formControlName="bankAffiliate">
              <mat-option>Select</mat-option>
              @for (
              nameType of piData.bankAffiliatesLookup
              | keyvalue : valueAscOrder
              ; track
              nameType) {
              <mat-option [value]="nameType.key">
                {{ nameType.value }}
              </mat-option>
              }
            </mat-select>
            <mat-hint class="bofa--skiplink">{{
              dropDownScreenReaderAffiliate()
              }}</mat-hint>
          </mat-form-field>
        </div>
      </div>
      }
      <div>
        <div class="bottom-space">
          <p id="pwc-radio-group">
            <abbr title="required">*</abbr> Have you ever been a
            <strong>full time</strong> employee (not an intern or contractor) of
            Price Waterhouse Cooper (PWC)?
          </p>
          <mat-radio-group name="radioPWC" aria-describedby="pwc-radio-group" class="minor-radio-padding"
            formControlName="pwc" required (change)="pwcChange($event)" (focusin)="radioOnFocus($event)"
            (focusout)="radioOnFocusOut($event)">
            <mat-radio-button class="minor-list-space radio-padding" value="1">Yes</mat-radio-button>
            <mat-radio-button class="minor-radio-padding" value="0">No</mat-radio-button>
            @if (submit && pwc.hasError('required')) {
            <mat-error>Please select Yes or No, have you ever been a
              <strong>full time</strong> employee (not an intern or contractor)
              of Price Waterhouse Cooper (PWC)?</mat-error>
            }
          </mat-radio-group>
        </div>
        @if (showPWC) {
        <div class="pwcDates has-background cool-gray-5 grey-box">
          <mat-form-field class="width-300-top-padding-right" hideRequiredMarker>
            <mat-label><abbr title="required">* </abbr>Employment From Date</mat-label>
            <input matInput [matDatepicker]="pwcStartDatePicker" [min]="minDate" [max]="maxDate"
              formControlName="pwcStartDate" maxLength="25" placeholder="mm/dd/yyyy" required />
            <mat-datepicker-toggle matSuffix [for]="pwcStartDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #pwcStartDatePicker></mat-datepicker>
            <mat-hint>Format mm/dd/yyyy</mat-hint>
            @if (pwcStartDate.errors) {
            <mat-error>Please enter valid Employment From Date</mat-error>
            }
          </mat-form-field>
          <mat-form-field class="width-300-top-padding-right bottom-space" hideRequiredMarker>
            <mat-label><abbr title="required">* </abbr>Employment To Date</mat-label>
            <input matInput [matDatepicker]="pwcEndDatePicker" [min]="minDate" [max]="maxDate"
              formControlName="pwcEndDate" maxLength="25" placeholder="mm/dd/yyyy" required />
            <mat-datepicker-toggle matSuffix [for]="pwcEndDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #pwcEndDatePicker></mat-datepicker>
            <mat-hint>Format mm/dd/yyyy</mat-hint>
            @if (pwcEndDate.errors) {
            <mat-error>Please enter valid Employment To Date</mat-error>
            }
          </mat-form-field>
        </div>
        }
      </div>
      @if (piData.displayPepQuestion) {
      <p id="haveconn-radio-group">
        <abbr title="required">*</abbr>
        <strong>Do you have a family member connection or business connection to any
          <u>senior officials</u> within a government or government controlled
          organization?</strong>
        i.e. officers of federal, state, county, and municipal governments;
        individuals holding a judicial position; members of parliaments,
        assemblies and political parties; ministers of state; members of a
        ruling monarchy or royal family; ministry and department heads; heads at
        central banks; or the chairman, managing director, director, senior
        advisors of government owed entities?
      </p>
      }
      @if (piData.displayPepQuestion) {
      <mat-radio-group name="radioHaveConnection" aria-describedby="haveconn-radio-group"
        class="bottom-space minor-radio-padding" formControlName="haveConnection" required
        (change)="radioOnChange($event)" (focusin)="radioOnFocus($event)" (focusout)="radioOnFocusOut($event)">
        <mat-radio-button class="minor-list-space radio-padding" value="1">Yes</mat-radio-button>
        <mat-radio-button class="minor-radio-padding" value="0">No</mat-radio-button>
        @if (submit && haveConnection.hasError('required')) {
        <mat-error>Please select Do you have a family member connection or business
          connection to any senior officials within a government or government
          controlled organization?</mat-error>
        }
      </mat-radio-group>
      }
      <!-- Hidden divs are for screen readers -->
      @if (piData.displayPepQuestion) {
      <div class="bofa--skiplink">
        @if (submit && showRadioHaveConnection) {
        <mat-error>
          Please select Do you have a family member connection or business
          connection to any senior officials within a government or government
          controlled organization?
        </mat-error>
        }
      </div>
      }
      @if (piData.applicantType != 'Internal') {
      <p id="contractor-radio-group" class="minor-list-space">
        <abbr title="required">* </abbr>Are you currently employed as a
        contractor with Bank of America or Merrill Lynch?
      </p>
      }
      @if (piData.applicantType != 'Internal') {
      <mat-radio-group name="radioCurrentContractor" aria-describedby="contractor-radio-group"
        class="bottom-space max-width minor-radio-padding" formControlName="currentContractor" required
        (change)="radioOnChange($event)" (focusin)="radioOnFocus($event)" (focusout)="radioOnFocusOut($event)">
        <mat-radio-button class="minor-list-space radio-padding" value="1">Yes</mat-radio-button>
        <mat-radio-button class="minor-radio-padding" value="0">No</mat-radio-button>
        @if (submit && currentContractor.hasError('required')) {
        <mat-error>Please select Are you currently employed as a contractor with Bank of
          America or Merrill Lynch?</mat-error>
        }
      </mat-radio-group>
      }
      <!-- Hidden divs are for screen readers -->
      <div class="bofa--skiplink">
        @if (submit && showRadioCurrentContractor) {
        <mat-error>
          Please select Are you currently employed as a contractor with Bank of
          America or Merrill Lynch
        </mat-error>
        }
      </div>
      <p id="other-radio-group" class="minor-list-space">
        <abbr title="required">* </abbr>Have you ever been known by any other
        name(s)?*
      </p>
      @if (!otherNameText) {
      <div id="other-sub-info" class="sub-label max-zoom minor-list-space">
        *This includes Maiden Name, Previous Legal Name, Alias Name, and
        Preferred Name
      </div>
      }
      @if (otherNameText) {
      <div id="other-sub-info" class="sub-label max-zoom minor-list-space">
        *{{ otherNameText }}
      </div>
      }
      <mat-radio-group name="radioOtherName" aria-describedby="other-radio-group other-sub-info"
        class="bottom-space max-width minor-radio-padding" (change)="onOtherNameChange($event)"
        formControlName="otherName" required (focusin)="radioOnFocus($event)" (focusout)="radioOnFocusOut($event)">
        <mat-radio-button class="minor-list-space radio-padding" value="1">Yes</mat-radio-button>
        <mat-radio-button class="minor-radio-padding" value="0">No</mat-radio-button>
        @if (submit && otherName.hasError('required')) {
        <mat-error>
          Please select Have you ever been known by any other
          name(s)?*</mat-error>
        }
      </mat-radio-group>
      <!-- Hidden divs are for screen readers -->
      <div class="bofa--skiplink">
        @if (submit && showRadioOtherName) {
        <mat-error>
          Please select Have you ever been known by any other name(s)
        </mat-error>
        }
      </div>
    </div>
    }
  </form>
</div>
} @else {
Loading personal information...
}

@if (!ousFlag) {
<div>
  <app-other-name [piData]="piData" [show]="showOtherName" #otherNames></app-other-name>
</div>
}
